import { __read, __spread } from "tslib";
import { formatValue as valueFormatter } from '@keen.io/charts-utils';
import { extractGroupBySettings } from '@keen.io/query';
import { KEEN_KEY, KEEN_VALUE, KEEN_ELEMENTS } from '@keen.io/parser';
import { VALUE } from '../../constants';
export var transform = function (_a) {
    var query = _a.query, chartSettings = _a.chartSettings;
    var data = chartSettings.data, tooltipSettings = chartSettings.tooltipSettings;
    var groupBy = query.group_by;
    var dataSeriesGroups = extractGroupBySettings(groupBy);
    var isMultiGroupBy = dataSeriesGroups.length > 1;
    var formatValue = tooltipSettings === null || tooltipSettings === void 0 ? void 0 : tooltipSettings.formatValue;
    var _b = __read(dataSeriesGroups, 1), geographicAreaProperty = _b[0];
    if (isMultiGroupBy) {
        var _c = __read(dataSeriesGroups, 2), groupProperty = _c[1];
        var columns = [geographicAreaProperty, groupProperty, VALUE];
        var rows_1 = [];
        data.forEach(function (item) {
            var groupElements = item[KEEN_ELEMENTS];
            var elementsKeys = Object.keys(item[KEEN_ELEMENTS]);
            rows_1.push.apply(rows_1, __spread(elementsKeys.map(function (keyName) { return [
                item[KEEN_KEY],
                keyName,
                valueFormatter(groupElements[keyName], formatValue),
            ]; })));
        });
        return __spread([columns], rows_1);
    }
    else {
        return __spread([
            [geographicAreaProperty, VALUE]
        ], data.map(function (item) { return [
            item[KEEN_KEY],
            valueFormatter(item[KEEN_VALUE], formatValue),
        ]; }));
    }
};
